export default {"src":"/_next/static/media/chevron-horizontal.06df2ea4.svg","height":32,"width":32};